export default {
      id: "icon-ads_accounts-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-ads_accounts",
      toString: function () {
        return this.url;
      }
    }